import React, { useContext } from "react";
import Skeleton from "@mui/material/Skeleton";
import { TableContext } from "../index";

export function RecentViolationsTableRowSkeleton({ index, hiddenHeaders = [] }) {
    const { config } = useContext(TableContext);

    return (
        <tr key={index}>
            <td>
                <Skeleton variant="rectangular" width={18} height={18} />
            </td>
            {hiddenHeaders.includes("DEVICE") ? null : <td>
                <Skeleton variant="text" width="80%" height={24} />
            </td>}
            {hiddenHeaders.includes("RULE NAME") ? null : <td>
                <Skeleton variant="text" width="90%" height={24} />
            </td>}
            {hiddenHeaders.includes("DESCRIPTION") ? null : <td>
                <Skeleton variant="text" width="100%" height={24} />
            </td>}
            {hiddenHeaders.includes("TYPE") ? null : <td>
                <Skeleton variant="text" width={120} height={24} />
            </td>}
            {hiddenHeaders.includes("VIOLATION DATE") ? null : <td>
                <Skeleton variant="text" width={140} height={24} />
            </td>}
            {/* <td>
                <Skeleton variant="text" width={100} height={24} />
            </td> */}
            {hiddenHeaders.includes("SEVERITY") ? null : <td>
                <Skeleton variant="rectangular" width={70} height={24} className="oct_skeleton-radius-4" />
            </td>}
            {config.showRemediated && !hiddenHeaders.includes("REMEDIATED DATE") &&
                <td>
                    <Skeleton variant="text" width={140} height={24} />
                </td>
            }
            <td className="oct_table-actions-cell-v2">
                <button className="oct_dropdown-trigger-v2 oct_skeleton-dropdown-btn" disabled>
                    <Skeleton variant="circular" width={24} height={24} />
                </button>
            </td>
        </tr>
    );
}

export default RecentViolationsTableRowSkeleton;
